import { useSearchParams } from 'react-router-dom';

const PaymentError = () => {
  const [searchParams] = useSearchParams();

  // Extract query parameters for debugging (if applicable)
  const errorMessage = searchParams.get('message');

  return (
    <div className="container">
      <h1>Payment Failed!</h1>
      <p>{errorMessage ? `Error: ${errorMessage}` : 'Something went wrong with the payment.'}</p>
      <p>Please try again later.</p>
    </div>
  );
};

export default PaymentError;
